import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetStatistics = createAsyncThunk<AxiosResponse<any, any>, any>(
  "statistics/toGetStatistics",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/statistics?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
